export default __webpack_public_path__ + "static/media/libra.eb22f92e.png";